import { stepValidationToNodeData } from './workflowValidation';

export function decorateNodesWithValidation(nodes, stepValidationMap) {
  return (nodes || []).map((node) => ({
    ...node,
    data: {
      ...node.data,
      ...stepValidationToNodeData(stepValidationMap?.get(node.id)),
    },
  }));
}

export function decorateEdgeWithValidation(edge, issues) {
  const hasError = Boolean(issues?.errors?.length);
  const hasWarning = Boolean(issues?.warnings?.length);
  const messages = [...(issues?.errors || []), ...(issues?.warnings || [])];

  return {
    ...edge,
    className: hasError
      ? 'workflow-edge--error'
      : hasWarning
        ? 'workflow-edge--warning'
        : undefined,
    style:
      hasError || hasWarning
        ? {
            stroke: hasError ? '#dc3545' : '#ffc107',
            strokeWidth: 2,
          }
        : undefined,
    labelStyle: edge.label
      ? {
          fill: hasError ? '#dc3545' : hasWarning ? '#b58100' : '#212529',
          fontSize: 12,
          fontWeight: 500,
        }
      : undefined,
    data: {
      ...(edge.data || {}),
      validationMessages: messages,
    },
  };
}

export function decorateEdgesWithValidation(edges, edgeValidationMap) {
  return (edges || []).map((edge) =>
    decorateEdgeWithValidation(edge, edgeValidationMap?.get(edge.id))
  );
}
